import React from 'react';
import { BarChart3, TrendingUp, MousePointer, Eye, Target } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { format } from 'date-fns';

const GoogleAnalyticsMetrics = ({ analytics, analyticsHistory }) => {
  const chartData = analyticsHistory?.map(item => ({
    date: format(new Date(item?.date), 'dd/MM'),
    'Trafic organique': item?.organic_traffic,
    'Impressions': item?.impressions / 100,
    'Clics': item?.clicks
  })) || [];

  return (
    <div className="space-y-6">
      {/* Metrics Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="p-3 rounded-lg border bg-blue-50 text-blue-600 border-blue-200">
              <TrendingUp size={24} />
            </div>
          </div>
          <h3 className="text-gray-600 text-sm font-medium mb-2">Trafic organique</h3>
          <p className="text-3xl font-bold text-gray-900">{analytics?.organicTraffic?.toLocaleString()}</p>
          <p className="text-xs text-gray-500 mt-1">Visiteurs/jour</p>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="p-3 rounded-lg border bg-purple-50 text-purple-600 border-purple-200">
              <Eye size={24} />
            </div>
          </div>
          <h3 className="text-gray-600 text-sm font-medium mb-2">Impressions</h3>
          <p className="text-3xl font-bold text-gray-900">{analytics?.impressions?.toLocaleString()}</p>
          <p className="text-xs text-gray-500 mt-1">Affichages dans les résultats</p>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="p-3 rounded-lg border bg-green-50 text-green-600 border-green-200">
              <MousePointer size={24} />
            </div>
          </div>
          <h3 className="text-gray-600 text-sm font-medium mb-2">Clics</h3>
          <p className="text-3xl font-bold text-gray-900">{analytics?.clicks?.toLocaleString()}</p>
          <p className="text-xs text-gray-500 mt-1">Clics depuis Google</p>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="p-3 rounded-lg border bg-orange-50 text-orange-600 border-orange-200">
              <Target size={24} />
            </div>
          </div>
          <h3 className="text-gray-600 text-sm font-medium mb-2">CTR moyen</h3>
          <p className="text-3xl font-bold text-gray-900">{analytics?.ctr?.toFixed(2)}%</p>
          <p className="text-xs text-gray-500 mt-1">Position: {analytics?.avgPosition?.toFixed(1)}</p>
        </div>
      </div>

      {/* Traffic Trend Chart */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="flex items-center mb-4">
          <BarChart3 className="w-6 h-6 text-green-600 mr-2" />
          <h3 className="text-lg font-semibold text-gray-900">Tendances du trafic organique</h3>
        </div>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="Trafic organique" stroke="#10b981" strokeWidth={2} />
            <Line type="monotone" dataKey="Clics" stroke="#3b82f6" strokeWidth={2} />
            <Line type="monotone" dataKey="Impressions" stroke="#8b5cf6" strokeWidth={2} />
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* Google Analytics Integration Info */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
        <div className="flex items-start">
          <BarChart3 className="w-6 h-6 text-blue-600 mr-3 mt-1" />
          <div>
            <h4 className="font-semibold text-blue-900 mb-2">Intégration Google Analytics</h4>
            <p className="text-sm text-blue-800 mb-3">
              Les données affichées proviennent de Google Analytics 4. Pour une analyse plus approfondie, consultez directement votre tableau de bord Google Analytics.
            </p>
            <a
              href="https://analytics.google.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm"
            >
              Ouvrir Google Analytics
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoogleAnalyticsMetrics;